
import React from "react";

import LogsParser from "../component/LogsParser"; 

const LogsParserContainer = ({ pageId }) => (<LogsParser pageId={pageId} />)

export default LogsParserContainer; 